import types from "../types";

export const fetchwatchhistory = (history) => ({
  type: types.historyTypes.FETCH_USER_WATCH_HISTORY,
  payload: history,
});

export const updatehistory = (history) => ({
  type: types.historyTypes.UPDATE_USER_WATCH_HISTORY,
  payload: history,
});
